import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../icon";
export default function Volume1(props) {
    return (_jsx(Icon, { ...props, children: _jsx("path", { d: "M11.433 4.099A1 1 0 0 1 12 5v14a1 1 0 0 1-1.625.78L5.65 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.65l4.725-3.78a1 1 0 0 1 1.058-.121ZM10 7.08l-3.375 2.7A1 1 0 0 1 6 10H3v4h3a1 1 0 0 1 .625.22L10 16.92V7.08ZM14.833 7.753a1 1 0 0 1 1.414 0 6 6 0 0 1 0 8.484 1 1 0 0 1-1.414-1.414 4 4 0 0 0 0-5.656 1 1 0 0 1 0-1.414Z" }) }));
}
